// @ts-nocheck
export default defineNuxtRouteMiddleware((to, from) => {
  // // to.meta.keepalive = false
  if (!import.meta.client) { return }
  if (to.name && (to.name.includes('product-slug-id') || ['nl-slug', 'de-slug', 'en-slug'].includes(to.name))) {
    to.meta.keepalive = true
  } else {
    to.meta.keepalive = false
  }
  if (from.name && (from.name.includes('product-slug-id') || ['nl-slug', 'de-slug', 'en-slug'].includes(from.name))) {
    from.meta.keepalive = true
  } else {
    from.meta.keepalive = false
  }
})
